import { useTranslation } from 'react-i18next';
import { getDateFnsLocale } from '../i18n/dateFnsLocales';

export function useDateLocale() {
  const { i18n } = useTranslation();
  return getDateFnsLocale(i18n.language);
}
